import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import { Link } from '@bibliocommons/base-links';
import { childrenShape } from '@bibliocommons/bc-prop-types';
import { getValidHtmlAttributes } from '@bibliocommons/utils-html';
import './Capsule.scss';

export default function Capsule({
  className,
  contentClassName,
  children,
  active,
  renderSecondaryInfo,
  dataKey,
  handleClick,
  role,
  ...props
}) {
  const contentClassNames = cn('capsule__content', contentClassName, {
    'capsule__content--active': active
  });

  const capsuleContent = props.href ? (
    <Link className={contentClassNames} dataKey="capsule-link" {...props}>
      {children}
    </Link>
  ) : (
    <div {...getValidHtmlAttributes(props, 'div')} className={contentClassNames}>
      {children}
    </div>
  );

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      data-key={dataKey}
      className={cn('cp-capsule', className)}
      onAuxClick={handleClick}
      onClick={handleClick}
      onKeyPress={handleClick}
      role={role}
    >
      {capsuleContent}
      {renderSecondaryInfo && <div className="secondary-info">{renderSecondaryInfo()}</div>}
    </div>
  );
}

Capsule.propTypes = {
  className: PropTypes.string,
  children: childrenShape.isRequired,
  contentClassName: PropTypes.string,
  dataKey: PropTypes.string,
  href: PropTypes.string,
  renderSecondaryInfo: PropTypes.func,
  handleClick: PropTypes.func,
  role: PropTypes.string,
  active: PropTypes.bool
};
